import Cookies from 'js-cookie';
import { GlobalCfg } from '../conf';
import { EntityType } from '../types.generated';

const mappings = {
    '%': '-PERCENT-',
    '#': '-HASH-',
    '?': '-QUESTION-',
};

const reverseMappings = {
    '-PERCENT-': '%',
    '-HASH-': '#',
    '-QUESTION-': '?',
};

const utilService = (() => {
    function debounce(func, delay) {
        let timeoutId;

        return function (...args) {
            clearTimeout(timeoutId);

            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    }

    // Encode special characters in a string to avoid conflicts with URL encoding
    function encodeSpecialChars(str) {
        return str.replaceAll(/[%#?]/g, (match) => mappings[match]);
    }

    // Decode special characters in a string
    function decodeSpecialChars(str) {
        return str.replaceAll(/-PERCENT-|-HASH-|-QUESTION-/g, (match) => reverseMappings[match]);
    }

    function getXsrfToken() {
        const xsrf = Cookies.get(GlobalCfg.XSRF_TOKEN);
        const xsrfParts = xsrf ? xsrf.split('|') : [];
        return xsrfParts[0] ? atob(xsrfParts[0]) : '';
    }

    function getLanguage() {
        const lang = Cookies.get(GlobalCfg.EDC_LANGUAGE) || 'en';

        Cookies.set('i18next', lang);
        Cookies.set('datahub-lang', lang);

        return lang;
    }

    function getEntityTypeFromUrn(urn: string): EntityType {
        return urn?.split(':')[2] === 'glossaryNode' ? EntityType.GlossaryNode : EntityType.GlossaryTerm;
    }

    return {
        debounce,
        encodeSpecialChars,
        decodeSpecialChars,
        getXsrfToken,
        getLanguage,
        getEntityTypeFromUrn,
    };
})();

export default utilService;
